import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress, Paper } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import ReCAPTCHA from "react-google-recaptcha";
import {
  AutocompleteElement,
  FormContainer,
  TextFieldElement,
  useForm,
} from "react-hook-form-mui";
import { useTranslation } from "react-i18next";
import useSubmitPublicCertificateDownloadForm from "src/publicCertificateDownload/data-access/useSubmitPublicCertificateDownloadForm";
import HorizontalVerticalTogglerLayout from "src/shared/Layouts/HorizontalVerticalTogglerLayout";
import useGetPublicCertificateDownloadFormParams from "../../data-access/useGetPublicCertificateDownloadFormParams";
import { publicCertificateDownloadSchema } from "./validationSchema";

function PublicCertificateDownloadForm() {
  const { t } = useTranslation();
  const { data, isLoading } = useGetPublicCertificateDownloadFormParams();
  const { mutate, isLoading: isLoadingSubmit } =
    useSubmitPublicCertificateDownloadForm();
  const formContext = useForm({
    resolver: yupResolver(publicCertificateDownloadSchema()),
  });
  const handleRecaptcha = async (value) => {
    formContext.setValue("g-recaptcha-response", value);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "80vw",
        mx: "auto",
        marginBottom: "2rem",
        gap: "1rem",
      }}
    >
      <h2>{t("Έλεγχος Γνησιότητας Πιστοποιητικών/Αντιγράφων")}</h2>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <FormContainer
          formContext={formContext}
          onSuccess={(data) => mutate(data)}
          onError={(formError) => {
            Object.entries(formError).forEach(([key, value]) => {
              value?.message
                ? enqueueSnackbar(value?.message, { variant: "error" })
                : null;
            });
          }}
        >
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1.5rem",
              mx: "auto",
              p: "1rem",
            }}
          >
            <h3>{t("Στοιχεία Πιστοποιητικού")}</h3>
            <HorizontalVerticalTogglerLayout>
              <TextFieldElement
                name={"protocol"}
                label={t("Αριθμός Πρωτοκόλλου Εγγράφου")}
                sx={{ width: { sm: "100%", md: "50%" } }}
              />
              <TextFieldElement
                fullWidth
                name={"gemi"}
                label={t("Αρ. ΓΕΜΗ")}
                sx={{ width: { sm: "100%", md: "50%" } }}
              />
            </HorizontalVerticalTogglerLayout>
            <AutocompleteElement
              autocompleteProps={{
                sx: { width: { sm: "100%", md: "100%" } },
                getOptionLabel: (option) =>
                  data?.data?.chambers?.find(
                    (chamber) => chamber.d05_id === option,
                  )?.d05_descr ?? "",
              }}
              name={"d05_id"}
              label={t("ΤΟΠΙΚΗ ΥΠΗΡΕΣΙΑ Γ.Ε.ΜΗ. που εξέδωσε το Έγγραφο")}
              options={
                data?.data?.chambers?.map((chamber) => chamber.d05_id) ?? []
              }
            />
            <ReCAPTCHA
              onChange={handleRecaptcha}
              sitekey={import.meta.env.VITE_REACT_APP_SITE_KEY}
            />
            <LoadingButton
              loading={isLoadingSubmit}
              sx={{ alignSelf: "start" }}
              type="submit"
              variant="contained"
            >
              {t("Υποβολή")}
            </LoadingButton>
          </Paper>
        </FormContainer>
      )}
    </Box>
  );
}

export default PublicCertificateDownloadForm;
